import beefBowl from '../../../../public/assets/recipes/freezeDried/beef-half-freeze-dried-bowl.webp'
import beefCloseup from '../../../../public/assets/recipes/freezeDried/beef-close-up.webp'
import chickenPrep from '../../../../public/assets/home/freeze-dried-ingredient-preparation.webp'
import beefPouch from '../../../../public/assets/recipes/freezeDried/product/25oz-freeze-dried-beef-pouch.webp'
import chickenPouch from '../../../../public/assets/recipes/freezeDried/product/25oz-freeze-dried-chicken-pouch.webp'
import chickenBowl from '../../../../public/assets/recipes/freezeDried/freeze-dried-half-bowl-chicken-v2.webp'
import { StaticImageData } from 'next/image'
import { TranslationKeys } from 'locales/translationKeys'
import { FreezeDriedProteins } from 'models/Pet'
import { RecipeDetailHeroProps } from './components/RecipeDetailHero'
import { RecipeDetailBenefitsProps } from './components/RecipeDetailBenefits'
import { NUTRITION_FREEZE_DRIED } from 'fixtures/nutrition'

type RecipeType = {
  hero: RecipeDetailHeroProps
  alternativeImage: StaticImageData
  benefits: RecipeDetailBenefitsProps
  ingredients: {
    label: TranslationKeys
    description: TranslationKeys
  }[]
  breadcrumb: TranslationKeys
  disclaimer1?: TranslationKeys
  disclaimer2?: TranslationKeys
}

type RecipesMap = {
  [key in FreezeDriedProteins]: RecipeType
}

export const freezeDriedRecipes: RecipesMap = {
  [FreezeDriedProteins.CHICKEN]: {
    breadcrumb: 'recipes:freeze-dried.breadcrumbs.chicken-recipe',
    hero: {
      imageSrc: chickenBowl,
      nutrition: NUTRITION_FREEZE_DRIED[FreezeDriedProteins.CHICKEN],
      imageAlt: 'recipes:freeze-dried.CHICKEN.hero.image',
      title: 'recipes:freeze-dried.CHICKEN.hero.header',
      description: 'recipes:freeze-dried.CHICKEN.hero.description',
      features: [
        { certification: 'recipes:freeze-dried.CHICKEN.hero.certifications.0' },
        { certification: 'recipes:freeze-dried.CHICKEN.hero.certifications.1' },
        {
          certification: 'recipes:freeze-dried.CHICKEN.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        { certification: 'recipes:freeze-dried.CHICKEN.hero.certifications.3' },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: 'recipes:ingredients-description',
        },
        {
          label: 'recipes:hero-v2.nutritional-information',
          description: 'recipes:freeze-dried.nutrition-description',
        },
        {
          label: 'recipes:hero-v2.safety',
          description: 'recipes:freeze-dried.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.freeze-dried',
          description: 'recipes:freeze-dried.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:freeze-dried.CHICKEN.hero.pricing',
    },
    alternativeImage: beefPouch,
    benefits: {
      imageSrc: chickenPrep,
      title: 'recipes:freeze-dried.CHICKEN.benefits.title',
      imageAlt: 'recipes:freeze-dried.CHICKEN.benefits.image',
      list: [
        'recipes:freeze-dried.CHICKEN.benefits.list.0',
        'recipes:freeze-dried.CHICKEN.benefits.list.1',
        'recipes:freeze-dried.CHICKEN.benefits.list.2',
      ],
    },
    ingredients: [
      {
        label: 'recipes:freeze-dried.CHICKEN.ingredients.0.name',
        description: 'recipes:freeze-dried.CHICKEN.ingredients.0.description',
      },
      {
        label: 'recipes:freeze-dried.CHICKEN.ingredients.1.name',
        description: 'recipes:freeze-dried.CHICKEN.ingredients.1.description',
      },
      {
        label: 'recipes:freeze-dried.CHICKEN.ingredients.2.name',
        description: 'recipes:freeze-dried.CHICKEN.ingredients.2.description',
      },
    ],
  },
  [FreezeDriedProteins.BEEF]: {
    breadcrumb: 'recipes:freeze-dried.breadcrumbs.beef-recipe',
    hero: {
      imageSrc: beefBowl,
      nutrition: NUTRITION_FREEZE_DRIED[FreezeDriedProteins.BEEF],
      imageAlt: 'recipes:freeze-dried.BEEF.hero.image',
      title: 'recipes:freeze-dried.BEEF.hero.header',
      description: 'recipes:freeze-dried.BEEF.hero.description',
      features: [
        { certification: 'recipes:freeze-dried.BEEF.hero.certifications.0' },
        { certification: 'recipes:freeze-dried.BEEF.hero.certifications.1' },
        {
          certification: 'recipes:freeze-dried.BEEF.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        { certification: 'recipes:freeze-dried.BEEF.hero.certifications.3' },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: 'recipes:ingredients-description',
        },
        {
          label: 'recipes:hero-v2.nutritional-information',
          description: 'recipes:freeze-dried.nutrition-description',
        },
        {
          label: 'recipes:hero-v2.safety',
          description: 'recipes:freeze-dried.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.freeze-dried',
          description: 'recipes:freeze-dried.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:freeze-dried.BEEF.hero.pricing',
    },
    alternativeImage: chickenPouch,
    benefits: {
      imageSrc: beefCloseup,
      title: 'recipes:freeze-dried.BEEF.benefits.title',
      imageAlt: 'recipes:freeze-dried.BEEF.benefits.image',
      list: [
        'recipes:freeze-dried.BEEF.benefits.list.0',
        'recipes:freeze-dried.BEEF.benefits.list.1',
        'recipes:freeze-dried.BEEF.benefits.list.2',
      ],
    },
    ingredients: [
      {
        label: 'recipes:freeze-dried.BEEF.ingredients.0.name',
        description: 'recipes:freeze-dried.BEEF.ingredients.0.description',
      },
      {
        label: 'recipes:freeze-dried.BEEF.ingredients.1.name',
        description: 'recipes:freeze-dried.BEEF.ingredients.1.description',
      },
      {
        label: 'recipes:freeze-dried.BEEF.ingredients.2.name',
        description: 'recipes:freeze-dried.BEEF.ingredients.2.description',
      },
    ],
  },
}
